function toutou_xy_titre_principal(date,ligne) {
  if(ligne == 1){
    return dateo.getJourMaj()+
      ' '+dateo.getDate()+
      ' '+dateo.getMois()+
      ' '+dateo.getFullYear();
  }else if (ligne == 2){
    return dateo.getHours();
  }else{
    return dateo.getJour()+
      ' '+dateo.getDate()+
      ' '+dateo.getMois()+
      ' '+dateo.getFullYear()+
      ' à '+dateo.getHours()+' h';
  }
}
